<template>
  <div class="tit1">
    <div class="main object-main" style="">
      <div class="main-center flex flex-cz-c flex-sp-s clearfix">
        <div class="title-wrap fl">
          <img class="icon1" src="../assets/quan.png" alt="">
          <div class="title-content flex flex-cz-c flex-sp-c flex-column">
            <img class="icon2" src="../assets/5G.png" alt="">
          </div>
        </div>
        <div style="margin-right: 10px;" class="fl">
          <div class="container1 flex flex-cz-c flex-sp-b">
            <div>
              <img style="width:22px;height:22px" src="../assets/43d0e88.png" alt="">
              总点击量
            </div>
            <div>{{total.click_num}}次</div>
          </div>
          <div class="container1 flex flex-cz-c flex-sp-b">
            <div>
              <img style="width: 24px;height:24px" src="../assets/df9483e.png" alt="">
              浏览时间
            </div>

            <div>{{total.total_time}}</div>
          </div>
        </div>
        <div>
          <div class="container2 flex flex-cz-c flex-sp-b">
            <a href="https://www.baidu.com/" target="_blank">
              <img style="width: 22px;height: 22px" src="../assets/seauch.png" alt="">
              百度
            </a>
            <div>排名:1</div>
          </div>
          <div class="container2 flex flex-cz-c flex-sp-b">
            <a href="https://www.sogou.com/" target="_blank">
              <img style="width: 22px;height: 22px" src="../assets/seauch.png" alt="">
             搜狗
            </a>
            <div>排名:2</div>
          </div>
          <div class="container2 flex flex-cz-c flex-sp-b">
            <a href="https://www.so.com/" target="_blank">
              <img style="width: 22px;height: 22px" src="../assets/seauch.png" alt="">
              360
            </a>
            <div>排名:3</div>
          </div>
        </div>
        <!--        =E9=BD=BF=E8=BD=AE-->
        <div id="level">
          <div id="content">
            <div id="gears">
              <div id="gears-static"></div>
              <div id="gear-system-1">
                <div class="shadow" id="shadow15"></div>
                <div id="gear15"></div>
                <div class="shadow" id="shadow14"></div>
                <div id="gear14"></div>
                <div class="shadow" id="shadow13"></div>
                <div id="gear13"></div>
              </div>
              <div id="gear-system-2">
                <div class="shadow" id="shadow10"></div>
                <div id="gear10"></div>
                <div class="shadow" id="shadow3"></div>
                <div id="gear3"></div>
              </div>
              <div id="gear-system-3">
                <div class="shadow" id="shadow9"></div>
                <div id="gear9"></div>
                <div class="shadow" id="shadow7"></div>
                <div id="gear7"></div>
              </div>
              <div id="gear-system-4">
                <div class="shadow" id="shadow6"></div>
                <div id="gear6"></div>
                <div id="gear4"></div>
              </div>
              <div id="gear-system-5">
                <div class="shadow" id="shadow12"></div>
                <div id="gear12"></div>
                <div class="shadow" id="shadow11"></div>
                <div id="gear11"></div>
                <div class="shadow" id="shadow8"></div>
                <div id="gear8"></div>
              </div>
              <div class="shadow" id="shadow1"></div>
              <div id="gear1"></div>
              <div id="gear-system-6">
                <div class="shadow" id="shadow5"></div>
                <div id="gear5"></div>
                <div id="gear2"></div>
              </div>
              <div class="shadow" id="shadowweight"></div>
              <div id="chain-circle"></div>
              <div id="chain"></div>
              <div id="weight"></div>
            </div>
          </div>
        </div>
        <!--更多-->
        <div class="more-wrap flex flex-cz-c">
          <img src="../assets/4d4d387.png" alt="">
          <a class="positionR">
            <img src="../assets/ee5b7d2.png" alt="">
            <img class="move-run" src="../assets/fbdea92.png" alt="">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {totalapi} from "../api/http.js"
  export default {
   name: 'tit1',
   data(){
     return{

     }
   },
   props:{
     total:{}
   },
   async created() {

    },
    methods: {

    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/tit.vue